module.exports = __webpack_public_path__ + "0c44c0c8eb0ea8a71f2e8a3ce468e425.png";


//////////////////
// WEBPACK FOOTER
// ./src/HomePage/bbb.png
// module id = 1893
// module chunks = 0